require('./reimburseInvestmentStep1.scss');
// @ vendor
const React = require('react');
const Immutable = require('immutable');
const PropTypes = require('prop-types');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @commons
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ components
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { AmountInput } = require('commonsComponents/amountInput');
// @ constants
const { BROKER_REIMBURSE_FUND_TOTAL, BROKER_REIMBURSE_FUND_PARTIAL, BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS } = require('constants/index');
const {
    WEALTH_FUNDS_PARTIAL_REIMBURSEMENT
} = require('constants/flagBasedFeatures');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

class ReimburseInvestmentStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.setAmount = this.setAmount.bind(this);
        this.setParticipation = this.setParticipation.bind(this);
    }

    setAmount(value) {
        this.props.onSetAmount(value);
    }

    setParticipation(value) {
        const { immInvestmentFund, balance, immReimburseInvestment } = this.props;
        const reimburseFund = immReimburseInvestment.getIn(['steps', 0,'reimburseFund']);
        const reimburseInvestment = immReimburseInvestment.getIn(['steps', 0,'reimburseInvestment']);
        let valueParticipation;
        const accountBalance = reimburseFund.getIn(['account', 'balance']);
        const accountCurrency = accountBalance.get('currency');
        const fundCurrency = balance.currency;
        if(
            accountCurrency === 'EUR' &&
            fundCurrency !== 'EUR' &&
            !!immInvestmentFund.get('totalValueEur')
        ) {
            valueParticipation = immInvestmentFund.getIn(['totalValueEur', 'amount'])
        } else {
            valueParticipation = reimburseInvestment.getIn(['netAssetValue', 'amount'])
        }
        const participationAmount = value * valueParticipation;
        this.props.onSetParticipation(value, participationAmount);
    }

    buildInfoSubs() {
        return (
            <OKMessage type="informative">
                <FormattedText value="brokerHireInvestmentStep1-info"/>
            </OKMessage>
        )
    }



    buildInput() {
        const { immMyInvestments, immReimburseInvestment, immFlagBasedFeatures } = this.props;
        const type = immReimburseInvestment.getIn(['steps', 0, 'type']);
        const customCategoryId2 = immReimburseInvestment.getIn(['steps', 0, 'reimburseInvestment', 'customCategoryId2']);
        const ffFundsPartialReimbursement = immFlagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
        const amount = immReimburseInvestment.getIn(['steps', 0, 'amount']);
        const amountDirty = immReimburseInvestment.getIn(['steps', 0, 'amountDirty']);
        const amountIsValid = immReimburseInvestment.getIn(['steps', 0, 'amountIsValid']);
        const contractNumber  = immReimburseInvestment.getIn(['steps', 0,'reimburseFund','contractNumber']);
        const actualfund = immMyInvestments.getIn(['products','funds','stocks'], Immutable.fromJS({})).find(fund => fund.get('contractNumber') === contractNumber);
        const balance = actualfund.getIn(['totalValueEur','amount'])
        const maxReimburseInvestmentPercentage = immMyInvestments.get('maxFundsPartialReimbursementPercentage');
        const maxAmount = balance * (maxReimburseInvestmentPercentage / 100);
        const isMoreThanRefund= amount > maxAmount;
        const label = formatText('brokerReimburseInvestmentStep1-amount', [
            immReimburseInvestment.getIn(['steps', 0, 'reimburseFund', 'currencyFund'])
        ]);
        const showInvalidAmountMssg = !amountIsValid && isMoreThanRefund;
        const msg = !showInvalidAmountMssg
            ? formatText('brokerReimburseInvestmentStep1-errorMessage')
            : (<FormattedTextWithComponents
                value="brokerReimburseInvestmentStep1-brokerReimburseInvestmentStep1_maxRefundErrorMessageParam"
                injectedComponents={[maxReimburseInvestmentPercentage]}
        />);

        if (type === BROKER_REIMBURSE_FUND_PARTIAL && !ffFundsPartialReimbursement) {
            return (
                <div className="reimburse-investment-step1__input-container">
                    <AmountInput
                        label={label}
                        min={0}
                        amount={amount}
                        hideFocusZero={true}
                        callback={this.setAmount}
                        error={(!amountIsValid && !amountDirty) || showInvalidAmountMssg}
                        errorMsg={msg}
                        language={getLanguage()}
                    />
                </div>
            )
        } else if (type === BROKER_REIMBURSE_FUND_PARTIAL && ffFundsPartialReimbursement) {
            switch(customCategoryId2) {
                case '':
                case '1':
                case '3':
                    return (
                        <div className="reimburse-investment-step1__input-container">
                            <AmountInput
                                label={formatText('brokerReimburseInvestmentStep1-amount_label')}
                                min={0}
                                amount={amount}
                                hideFocusZero={true}
                                callback={this.setAmount}
                                error={(!amountIsValid && !amountDirty) || showInvalidAmountMssg}
                                errorMsg={msg}
                                language={getLanguage()}
                            />
                        </div>
                    )
                case '2':
                    const participation = immReimburseInvestment.getIn(['steps', 0, 'participation']);
                    const participationAmount = immReimburseInvestment.getIn(['steps', 0, 'participationAmount']);
                    const reimburseInvestment = immReimburseInvestment.getIn(['steps', 0,'reimburseInvestment']);
                    const currency = reimburseInvestment.getIn(['netAssetValue', 'currency']);
                    const language = getLanguage();
                    const netAssetDayEndValue = {
                        amount: participationAmount,
                        currency: currency,
                        decimalsLength: BROKER_FUNDS_NET_ASSET_DAY_END_VALUE_DECIMALS
                    };
                    const plainAmountObject = getPlainAmountObject(netAssetDayEndValue);
                    const instructionsMessage = (
                      <div>
                        <FormattedText
                          value={'brokerReimburseInvestmentStep1-approximate_amount'}
                        />
                        <OneLineSymbolAmount
                          amountObject={plainAmountObject}
                          language={language}
                          amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                      </div>
                    );
                    return (
                        <div className="reimburse-investment-step1__input-container">
                            <AmountInput
                                label={formatText('brokerReimburseInvestmentStep1-participation_label')}
                                min={0}
                                amount={participation}
                                hideFocusZero={true}
                                callback={this.setParticipation}
                                error={(!amountIsValid && !amountDirty) || showInvalidAmountMssg}
                                errorMsg={formatText('brokerReimburseInvestmentStep1-participation_error')}
                                language={getLanguage()}
                                instructionsMessage={instructionsMessage}
                                removeDecimals={false}
                                maxBackEndFractionLength={5}
                            />
                        </div>
                    )
                    break;

            }
        }
    }

    buildRadioButtons() {
        const { immReimburseInvestment, immFlagBasedFeatures } = this.props;
        const type = immReimburseInvestment.getIn(['steps', 0, 'type']);
        const ffFundsPartialReimbursement = immFlagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT)
        return (
            <RadioButtonGroup
                name="motive"
                idPrefix="cancelChequebookMotiveRadio"
                className="reimburse-investment-step2__radio-button-group"
                selectedValue={type}
                onChange={this.props.onChangeType}
            >
                <RadioButton
                    value={BROKER_REIMBURSE_FUND_TOTAL}
                    label={formatText('brokerReimburseInvestmentStep1-total')}
                    className="reimburse-investment-step2__radio-button-yes"
                />
                <RadioButton
                    value={BROKER_REIMBURSE_FUND_PARTIAL}
                    label={ffFundsPartialReimbursement ? formatText('brokerReimburseInvestmentStep1-partial_participation') : formatText('brokerReimburseInvestmentStep1-partial')}
                    className="reimburse-investment-step2__radio-button-no"
                />
            </RadioButtonGroup>
        )

    }

    render() {
        const title = formatText('brokerReimburseInvestmentStep1-title');
        const inputContainer = this.buildInput();
        let infoSubs;
        const radioButtons = this.buildRadioButtons();

        if (this.props.immReimburseInvestment && !this.props.immReimburseInvestment.get('submitSuccessful')) {
            infoSubs = this.buildInfoSubs();
        }

        return (
            <div className="reimburse-investment-step1">
                <header className="reimburse-investment-step1__header">
                    <h2 className="reimburse-investment-step1__title">
                        {title}
                    </h2>
                </header>
                <div>
                    <FormattedText value="brokerReimburseInvestmentStep1-details" className=""/>
                </div>
                <div className="reimburse-investment-step1__subtitle">
                    <FormattedText value="brokerReimburseInvestmentStep1-type" />
                </div>
                <div className="reimburse-investment-step1__input-group">
                    {radioButtons}
                    {inputContainer}
                </div>

                {infoSubs}
            </div>
        );
    }
}

ReimburseInvestmentStep1.defaultProps = {
    owner: ''
};

ReimburseInvestmentStep1.propTypes = {
    immMyInvestments: PropTypes.object.isRequired,
    immReimburseInvestment: PropTypes.object.isRequired,
    onSetAmount: PropTypes.func,
    onChangeType: PropTypes.func.isRequired,
    onSetParticipation: PropTypes.func,
    immInvestmentFund: PropTypes.object.isRequired
};

module.exports = ReimburseInvestmentStep1;
